export default __webpack_public_path__ + "static/media/22.1c38ab65.jpg";